const type = 'SET_NEW_CARD_REASONS';

const setNewCardReasons = (data) => ({
  data,
  type,
});

export { type };
export default setNewCardReasons;
